import { defineComponent, h, shallowRef } from "vue";

import MosaicLoader from "@/components/Mosaic/MosaicLoader.vue";

export function defineMosaicComponent<T>(componentName: string): T {
  const component = defineComponent({
    name: componentName.slice(componentName.lastIndexOf("/") + 1),
    inheritAttrs: false,
    setup(_, { attrs, expose, slots }) {
      const componentRef = shallowRef<Record<PropertyKey, unknown>>();

      expose(
        new Proxy<Record<string, unknown>>(
          {},
          {
            get: (_, property) => (componentRef.value == null ? undefined : Reflect.get(componentRef.value, property)),
            has: (_, property) => componentRef.value != null && Reflect.has(componentRef.value, property),
          },
        ),
      );

      return () => h(MosaicLoader, { ...attrs, componentName, componentRef }, slots);
    },
  });

  return component as unknown as T;
}
